import script from "./TextStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TextStylePanel.vue?vue&type=style&index=0&id=1248c90c&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1248c90c"]])

export default __exports__